export default "__VITE_ASSET__D9Z_ojVD__"